

<ng-container *ngIf="localeState$ | async as localeState">
  <h2 mat-dialog-title>
    {{'Language' | translatelayout: localeState.locale}}
    <i class="fa fa-close pull-right" style="cursor: pointer;" (click)="closeModal()"></i>
  </h2>
  
  <p>{{'Your language selection will be applied throughout the application.' | translatelayout: localeState.locale}}</p>  
  
  <button mat-button style="margin-right: 0.5em; border: 1px solid #ddd;" [disabled]="locale === 'en'" (click)="english(localeState)">
    {{ 'English' | translatelayout: localeState.locale }}
  </button>
  <button mat-button style="border: 1px solid #ddd;" [disabled]="locale === 'fr-CA'" (click)="french(localeState)">
    {{ 'French' | translatelayout: localeState.locale }}
  </button>
</ng-container>
